<ng-container
  [ngTemplateOutlet]="formatedOptions.length ? dropdownButton : button"
></ng-container>

<ng-template #dropdownButton>
  <pr-button-dropdown
    display="neutral"
    [logo]="buttonIcon"
    [expandIcon]="buttonIcon"
    [tooltips]="buttonLabel"
    [label]="buttonLabel"
    (onOpened)="focusSearchInput()"
  >
    <div class="search-input">
      <input #searchInput [(ngModel)]="searchValue" #ctrl="ngModel" />
      <pr-icon name="search"></pr-icon>
    </div>
    <ul>
      @for (option of formatedOptions; track option) {
        <li (click)="ctrl.reset(); optionSelected.emit(option)">
          {{ option.name }}
        </li>
      }
    </ul>
  </pr-button-dropdown>
</ng-template>

<ng-template #button>
  <pr-button
    display="neutral"
    rightIcon="add"
    [tooltip]="buttonLabel"
    [label]="buttonLabel"
  ></pr-button>
</ng-template>
